import { render, staticRenderFns } from "./thumb.vue?vue&type=template&id=fd357d88&scoped=true&"
import script from "./thumb.vue?vue&type=script&lang=js&"
export * from "./thumb.vue?vue&type=script&lang=js&"
import style0 from "./thumb.vue?vue&type=style&index=0&id=fd357d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd357d88",
  null
  
)

export default component.exports